import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState } from './types'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'

export default () => {
  const [mounted, setMounted] = useState<boolean>(false)

  const history = useHistory()
  const dispatch = useDispatch()
  const alert = useAlert()

  const { courses, isFetching, error } = useSelector(
    (state: { coursesList: InitialState }) => state.coursesList
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  useEffect(() => {
    dispatch(actions.fetchCoursesList())
    setMounted(true)
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (courses.length && !isFetching && mounted) {
      const id = courses[0].course_id
      history.replace(`/courses/${id}`)
    }
  }, [isFetching])

  return (
    <>
      <Header />
      <div className={'container'}>
        <LoadingPage />
        {/* Страница листа курсов*/}
        {/* <br />*/}
        {/* {isFetching ? <span>Загрузка курсов...</span> : null}*/}
        {/* <ul>*/}
        {/*  {courses.map((i: CourseType) => (*/}
        {/*    <li key={i.course_id}>*/}
        {/*      <a href={`/courses/${i.course_id}`}>{i.title}</a>*/}
        {/*    </li>*/}
        {/*  ))}*/}
        {/* </ul>*/}
      </div>
      <Footer />
    </>
  )
}
